import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';

import StreakCard from 'challenge/common/StreakCard';
import Goal from './Goal';
import { Wrapper, HorizontalRuler } from './elements';
import { useText } from 'common/hooks';

const deps = {
  insights: state.challenge.visualisations.computedPersonalInsights,
  startOfDays: state.challenge.campaign.challenge.startOfDays,
  streakModalClicked: sequences`challenge.info.streakModalClicked`,
};

export function GoalAndStreak({
  insights,
  startOfDays = [],
  streakModalClicked,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <Wrapper>
      <Goal />
      <HorizontalRuler />
      <StreakCard
        onStreakClicked={() => streakModalClicked()}
        data={insights?.streakInfo?.data}
        title={
          insights?.streakInfo?.title
            ? t(
                `challenge.ChaPaD24B.PersonalInsights.streaks.title.${insights.streakInfo?.title}`,
                {
                  streak: insights?.currentStreak?.length,
                  totalLogged: insights?.streakInfo?.daysLogged,
                  totalDays: startOfDays?.length,
                }
              )
            : ''
        }
        text={
          insights?.streakInfo?.text
            ? t(
                `challenge.ChaPaD24B.PersonalInsights.streaks.text.${insights?.streakInfo?.text}`,
                {
                  totalDays: startOfDays.length,
                }
              )
            : ''
        }
      />
    </Wrapper>
  );
}

export default connect(deps, GoalAndStreak);
